import {
  TextField,
  Box,
  Dialog,
  Grid,
  Button,
  FormControl,
  Select,
  MenuList,
  MenuItem,
  InputLabel,
  Typography,
  Stack,
} from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { styled } from "styled-components";
import HttpService from "../../../../../hooks/Https-services";
import useConfig from "../../../../../hooks/useConfig";
import PageRoutes, { APIRoutes } from "../../../../../utils/constants";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import FormHelpText from "rsuite/esm/FormHelpText";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
const SliderForm = ({ initalValue, fileUrl, setFileUrl }: any) => {
  const configData = useConfig();
  const { id }: any = useParams();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [channelOption, setChannelOption] = useState([]);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const validate = (values: any) => {
    let errors: any = {};

    if (!values.seasonId) {
      errors["seasonId"] = "This field is Required";
    }
    if (!values.images && id == 0) {
      errors["images"] = "This field is Required";
    }
    return errors;
  };
  const formik: any = useFormik({
    initialValues: initalValue,
    validate,
    validateOnChange: false,
    onSubmit: async (values) => {
      try {
        var bodyFormData = new FormData();
        bodyFormData.append("Name", values.name);
        bodyFormData.append("Description", values.description);
        bodyFormData.append("DisplayText", values.displayText);
        bodyFormData.append("FontSize", values.fontSize);
        bodyFormData.append("FontColor", values.fontColor);
        bodyFormData.append("Priority", values.priority);
        bodyFormData.append("WatchUrl", values.seasonId);

        if (id != 0) {
          if (values.images) {
            bodyFormData.append("Image", values.images);
          }
          const res = await HttpService.postImage(
            APIRoutes.UpdateHomeSlider.replace(":id", id),
            bodyFormData
          );
        } else {
          if (!values.images) {
            toast.error("Please Upload Image");
            return;
          }
          bodyFormData.append("Image", values.images);

          const res = await HttpService.postImage(
            APIRoutes.CreateSlider,
            bodyFormData
          );
        }
        navigate(PageRoutes.SliderSetting);
      } catch (error: any) {
        toast.error(error.response.data.message);
      }
    },
  });
  const FetchChannels = async () => {
    try {
      const result = await HttpService.getapi(
        APIRoutes.ChannelOption.replace(":id", configData.customer)
      );

      setChannelOption(result.data.data);
    } catch (error) {}
  };
  useEffect(() => {
    FetchChannels();
  }, []);

  const checkPhotoIsInSize = (fileUpload: any) => {
    var reader = new FileReader();

    //Read the contents of Image File.
    reader.readAsDataURL(fileUpload[0]);
    reader.onload = function (e: any) {
      //Initiate the JavaScript Image object.
      var image: any = new Image();

      //Set the Base64 string return from FileReader as source.
      image.src = e.target.result;

      //Validate the File Height and Width.
      image.onload = function () {
        var height = this.height;
        var width = this.width;

        if (height == 1096 && width == 2560) {
          formik.setFieldValue("images", fileUpload[0]);
          setFileUrl(URL.createObjectURL(fileUpload[0]));

          return true;
        } else {
          toast.error("Images must be 2560px(width) x 1096px(height)");
          return false;
        }
      };
    };
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            placeholder="Name"
            id="name"
            name="name"
            type={"text"}
            label={"Name"}
            error={formik.errors.name ? true : false}
            helperText={formik?.errors?.name}
            value={formik.values.name}
            variant="outlined"
            inputProps={{
              "aria-label": "Name",
            }}
            aria-describedby="outlined-weight-helper-text"
            onChange={(e: any) => {
              formik.handleChange(e);
              formik.errors.name = "";
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label={"Description"}
            placeholder="Description"
            id="description"
            name="description"
            error={formik.errors.description ? true : false}
            helperText={formik?.errors?.description}
            value={formik.values.description}
            onChange={(e: any) => {
              formik.handleChange(e);
              formik.errors.description = "";
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            placeholder="Display Text"
            label="Display Text"
            id="displayText"
            name="displayText"
            error={formik.errors.displayText ? true : false}
            helperText={formik?.errors?.displayText}
            value={formik.values.displayText}
            onChange={(e: any) => {
              formik.handleChange(e);
              formik.errors.displayText = "";
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Font Size</InputLabel>
            <Select
              fullWidth
              id="demo-simple-select"
              labelId="demo-simple-select-label"
              placeholder="Font Size"
              label="Font Size"
              name="fontSize"
              error={formik.errors.fontSize ? true : false}
              value={formik.values.fontSize}
              onChange={(e: any) => {
                formik.handleChange(e);
                formik.errors.fontSize = "";
              }}
            >
              <MenuItem value={"8"}>8</MenuItem>
              <MenuItem value={"10"}>10</MenuItem>
              <MenuItem value={"12"}>12</MenuItem>
              <MenuItem value={"14"}>14</MenuItem>
              <MenuItem value={"16"}>16</MenuItem>
              <MenuItem value={"18"}>18</MenuItem>
              <MenuItem value={"20"}>20</MenuItem>
              <MenuItem value={"22"}>22</MenuItem>
              <MenuItem value={"24"}>24</MenuItem>
              <MenuItem value={"26"}>26</MenuItem>
              <MenuItem value={"28"}>28</MenuItem>
              <MenuItem value={"30"}>30</MenuItem>
              <MenuItem value={"32"}>32</MenuItem>
              <MenuItem value={"34"}>34</MenuItem>
              <MenuItem value={"36"}>36</MenuItem>
              <MenuItem value={"38"}>38</MenuItem>
              <MenuItem value={"40"}>40</MenuItem>
              <MenuItem value={"42"}>42</MenuItem>
              <MenuItem value={"44"}>44</MenuItem>
              <MenuItem value={"46"}>46</MenuItem>
              <MenuItem value={"48"}>48</MenuItem>
              <MenuItem value={"50"}>50</MenuItem>
              <MenuItem value={"52"}>52</MenuItem>
              <MenuItem value={"54"}>54</MenuItem>
              <MenuItem value={"56"}>56</MenuItem>
              <MenuItem value={"58"}>58</MenuItem>
              <MenuItem value={"60"}>60</MenuItem>
              <MenuItem value={"62"}>62</MenuItem>
              <MenuItem value={"64"}>64</MenuItem>
              <MenuItem value={"66"}>66</MenuItem>
              <MenuItem value={"68"}>68</MenuItem>
              <MenuItem value={"70"}>70</MenuItem>
              <MenuItem value={"72"}>72</MenuItem>
            </Select>
            <FormHelpText
              style={{ display: formik?.errors?.fontSize ? "flex" : "none" }}
            >
              {formik?.errors?.fontSize}
            </FormHelpText>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            type={"color"}
            label="Select Text Colour"
            placeholder="Font Color"
            id="fontColor"
            name="fontColor"
            error={formik.errors.fontColor ? true : false}
            helperText={formik?.errors?.fontColor}
            value={formik.values.fontColor}
            onChange={(e: any) => {
              formik.handleChange(e);
              formik.errors.fontColor = "";
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Select Target Channel
            </InputLabel>
            <Select
              label={"Select Target Channel"}
              placeholder="Season Id"
              id="seasonId"
              name="seasonId"
              error={formik.errors.seasonId ? true : false}
              value={formik.values.seasonId}
              onChange={(e: any) => {
                formik.handleChange(e);
                formik.errors.seasonId = "";
              }}
            >
              {channelOption?.map((el: any) => (
                <MenuItem value={el.channel_id}>{el?.channel_name}</MenuItem>
              ))}
            </Select>
            <FormHelpText> {formik?.errors?.seasonId}</FormHelpText>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack>
            <Button
              component="label"
              variant="contained"
              startIcon={<CloudUploadIcon />}
            >
              Upload Image
              <VisuallyHiddenInput
                type="file"
                accept=".png"
                onChange={(e) => checkPhotoIsInSize(e.target.files)}
              />
            </Button>

            <Typography variant="caption" color={"warning"}>
              Sliders must be PNGs and 2560px(width) x 1096px(height)
            </Typography>
          </Stack>
        </Grid>
      </Grid>
      {fileUrl && (
        <Box sx={{ width: "200px", py: 2 }}>
          <img onClick={handleClickOpen} src={fileUrl} width={"100%"} />
        </Box>
      )}

      <Dialog
        open={open}
        maxWidth={"md"}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <img src={fileUrl} width={"100%"} />
      </Dialog>
      <Box
        sx={{
          display: "flex",
          width: 1,

          justifyContent: "flex-end",
        }}
      >
        <Box sx={{ maxWidth: "200px" }}>
          <button
            type="submit"
            //   onClick={() => handelDeleteSlider(row?.ID)}
            style={{
              margin: "20px 0px",
              cursor: "pointer",
            }}
            className={configData.buttonCommonClass}
          >
            Submit
          </button>
        </Box>
      </Box>
    </form>
  );
};
export default SliderForm;
